import React from 'react'
import { NavText } from '../../../../components/NavElements'
import classes from './EmployerRightSide.module.css'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../State/Store'


export const EmployerRightSide = ()=>{
    
    const user = useSelector((state: IRootState)=>state.user)
    
    return (
    <div className={classes.rightSide}>
        <div className={classes.companyInfo}>
            <img src={user.picture} alt='Logo' className={classes.companyImage}/>
            <p className={classes.companyName}>{user.companyName}</p>
        </div>
        <NavText to='/Employer/home'>
        <div className={classes.Element}>
            <p>الرئيسية</p>
        </div>
        </NavText>
        <NavText to='/Employer/page'>
        <div className={classes.Element}>
            <p>صفحة العمل</p>
        </div>
        </NavText>
        <NavText to='/employer/jobs'>
        <div className={classes.Element}>
            <p>ادارة الوظائف</p>
        </div>
        </NavText>
        <NavText to='/employer/settings'>
        <div className={classes.Element}>
            <p>تعديل البيانات</p>
        </div>
        </NavText>
        <NavText to='/employer/report'>
        <div className={classes.Element}>
            <p>الإبلاغ عن مشكلة</p>
        </div>
        </NavText>
    </div>      
)
}
